module.exports = __webpack_public_path__ + "img/1440.5427d82e.jpg";